<template>
  <div class="pb-16 pt-6 lg:py-24">
    <div class="mx-auto w-full max-w-screen-xl container">
      <VcTypography :tag="heading" class="text-2xl">{{ title }}</VcTypography>
      <p>{{ subtitle }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface IProps {
  heading: string;
  title: string;
  subtitle?: string;
  background?: string;
}

defineProps<IProps>();
</script>

<style lang="scss">
.title-block {
  &.bg-neutral-800 {
    color: white;
  }
}
</style>
